export const DsFabDefaultProps = {
    size: 'medium',
    color: 'secondary'
};
